import React, { Component } from "react";
import { connect } from "react-redux";
import { Stage } from "react-konva";
import Background from "../Drawings/background";
import ChamberBed from "../Drawings/chamber-bed";
import PipeBed from "../Drawings/Pipes/pipe-bed-component";
import ScaleLine from "../Drawings/scaleline";
import AddRemoveTool from "../Drawings/add-remove-tool";
import StoneBed from "../Drawings/stone-bed";
import {
    setDimensions,
    addPressedKey,
    deletePressedKey,
    scaleStage,
    positionStage,
    switchPanning,
    getStagePosition,
    getStageScale,
} from "../../actions/viewport-actions";
import {
    pipeBedSetCentralizedCoordinates,
    setPipeDesign,
} from "../../actions/pipe-bed-actions";
import {
    chamberBedSetCentralizedCoordinates,
} from "../../actions/chamber-bed-actions";
import {
    GLOBAL_PROJECT_TYPE_CHAMBER,
    GLOBAL_PROJECT_TYPE_PIPE,
} from "../../lib/types";
import "./index.css";
import SystemBuilder from "../Builders/system-builder";
import ManifoldBuilder from "../Builders/manifold-builder";
import MeasureLength from "../Drawings/measure-length";
import ProjectSelectors from "../../reducers/project-reducer";
import { Pivot, PivotItem, PivotLinkFormat } from "office-ui-fabric-react/lib/Pivot";
import { Icon } from "office-ui-fabric-react";
import { modalAlertActions } from "../../actions/modal-alert.actions";
import {
    showUnsavedChangesDialog,
    hideUnsavedChangesDialog,
    setSelectedTabKey,
    updatePlaceholder,
    loadingBed,
    setSelectedBed,
    setDirtyStateForMultiBeds,
    updatedBedValues,
    updatedSelectedBedValues,
} from "../../actions/multi-bed-actions";
import { Dialog, DialogContent, DialogFooter, DialogType } from "office-ui-fabric-react";
import { DefaultButton, PrimaryButton } from "office-ui-fabric-react/lib-commonjs/Button";
import SubProjectService from "../../lib/services/sub-project-service";
import { clearViewPort, setCurrentSubProject } from "../../actions/sub-project-actions";
import { clearMainManifoldsState } from "../../actions/manifold-actions";
import { getSubProjectStateToPersist, restoreSubProjectPersistedState } from "../../actions/sub-project-crud-actions";
import Placeholder from "../Drawings/MultiBed/placeholder";
import MultibedSelectors from "../../reducers/multi-bed-reducer";
import { getScaledValue } from "../../actions/calculations-actions";
import MultiBedService from "../../lib/services/multibed-service";
import { getStateToPersist } from "../../actions/project-crud-actions";
import { buildProjectAutomation, buildPipeProjectAutomation } from "../../actions/submit-dialog-actions";
import { backgroundEdit, scaleEditSwitch, scaleUnitValueChange } from "../../actions/drawingtoolbar-actions";
import Project from "../../lib/project";
import { emitLineLenght } from "../../actions/measuretool-actions";

class Viewport extends Component{
    state = {
        dimensionsComputed: false,
        nextTabKey: null,
        previousTabKey: null,
    };

    constructor( props ) {
        super(props);
        this.keyPressed = this.keyPressed.bind(this);
        this.keyUp = this.keyUp.bind(this);
    }

    scale() {
        const { viewportScaleX: scaleX, viewportScaleY: scaleY } = this.props;
        let stage = this.stageNode.getStage();
        stage.scale({ x: scaleX, y: scaleY });
        stage.batchDraw();
    }

    position() {
        const { viewportPositionX: positionX, viewportPositionY: positionY } = this.props;
        let stage = this.stageNode.getStage();
        stage.position({ x: positionX, y: positionY });
        stage.batchDraw();
    }

    /**
     * Determine if MiniCAD is running inside an iFrame
     * This method will determine if MiniCAD is running inside an iFrame. This means
     * that it is an instance used for authentication by the azure AD library. We don't
     * want to rerender the entire app in the iframe again.
     */
    isInsideIframe() {
        return window.self !== window.top;
    }

    keyPressed( event ) {
        // if key is NOT in global pressed key set, add it
        if (
            !this.props.pressedKeys.has(event.key) &&
            this.props.keysOfInterest.has(event.key)
        ) this.props.addPressedKey(event.key);
    }

    keyUp( event ) {
        // if key IS in global pressed key set, remove it
        if (
            this.props.pressedKeys.has(event.key) &&
            this.props.keysOfInterest.has(event.key)
        ) this.props.deletePressedKey(event.key);
    }

    handleZoom( event ) {
        event.preventDefault();

        const oldScaleX = this.props.viewportScaleX;
        const oldScaleY = this.props.viewportScaleY;
        let stage = this.stageNode.getStage();

        // NOTE: Make sure you find the old mouse point before you set the scale
        const oldMousePoint = {
            x: stage.getPointerPosition().x / oldScaleX - stage.x() / oldScaleX,
            y: stage.getPointerPosition().y / oldScaleY - stage.y() / oldScaleY,
        };

        let newScale = event.deltaY < 0 ?  // Scrolling up: zoom in; scrolling down: zoom out
            this.props.viewportScaleX + 0.25 :
            this.props.viewportScaleX - 0.25;

        newScale = newScale.step(0.25).clamp(0.1, 5);

        this.props.scaleStage(newScale, newScale);

        // NOTE: Find the new mouse point with the new scale applied
        const newMousePoint = {
            x: -( oldMousePoint.x - stage.getPointerPosition().x / newScale ) * newScale,
            y: -( oldMousePoint.y - stage.getPointerPosition().y / newScale ) * newScale,
        };

        this.props.positionStage(newMousePoint.x, newMousePoint.y);
    }

    componentDidMount() {
        // if is running inside an iframe return
        if (this.isInsideIframe()) {
            return;
        }
        // set the stage object to global state
        window.konvaStage = this.stageNode.getStage();

        // bind the key event listeners
        document.addEventListener("keydown", this.keyPressed, false);
        document.addEventListener("keyup", this.keyUp, false);

        // set the computed dimensions, these props comes from
        //the upper component and not from the redux store, i.e.
        //are computed properties to determine the dimensions of
        //the viewport
        this.props.setDimensions(this.props.height, this.props.width);

        // disable context menu in the viewport
        this.stageContainer.addEventListener("contextmenu", e => {
            e.preventDefault();
        });

        // handle zoom event
        this.stageContainer.addEventListener("wheel",
            event => {
                this.handleZoom(event);
            },
        );

        // prevent scrolling in stage if using mouse-wheel dragging and change cursor
        this.stageContainer
            .onmousedown = ( e ) => {
            if (e.button === 1) {
                this.stageNode.getStage().container().style.cursor = "grab";
                this.props.switchPanning(true);
                return false;
            }
        };

        this.stageContainer
            .onmouseup = ( e ) => {
            if (e.button === 1) {
                this.props.switchPanning(false);
                return false;
            }
        };
    }

    componentDidUpdate( prevProps ) {
        if (prevProps.viewportScaleX !== this.props.viewportScaleX ||
            prevProps.viewportScaleY !== this.props.viewportScaleY) {
            this.scale();
        }

        /* if computed viewport dimensions have changed, reposition the pipe bed */
        if (this.anyPropHasChanged(prevProps, ["computedHeight", "computeWidth"]) &&
            !this.state.dimensionsComputed
        ) {
            this.props.pipeBedSetCentralizedCoordinates({
                x: ( this.props.computeWidth * 0.5 ) / 2 + ( this.props.bedWidth ) / 2,
                y: ( this.props.computedHeight * 1.15 ) / 2 - ( this.props.bedLength ) / 2,
            });
            /* when drag ends, set position into state */
            this.props.chamberBedSetCentralizedCoordinates({
                x: this.props.computeWidth / 2 + ( this.props.chamberbedHeight * this.props.chamberbedScaleX ) / 2,
                y: this.props.computedHeight / 2 - ( this.props.chamberbedWidth * this.props.chamberbedScaleY ) / 2,
            });
            /* do this only when viewport is set */
            this.setState({
                dimensionsComputed: true,
            });
        }

        if (this.props.isPanning) {
            this.stageNode.getStage().container().style.cursor = "grab";
            // his.stageNode.getStage().container().style.cursor = 'crosshair';
        } else {
            if (this.stageNode)
                this.stageNode.getStage().container().style.cursor = "default";
        }

        if (prevProps.isMultiBedProject !== this.props.isMultiBedProject) {
            // set the stage object to global state
            window.konvaStage = this.stageNode.getStage();
        }
    }

    componentWillUnmount() {
        /* remove the key event listeners */
        document.removeEventListener("keydown", this.keyPressed, false);
        document.removeEventListener("keyup", this.keyUp, false);
    }

    anyPropHasChanged( prevProps, propNames ) {
        let changed = false;
        for (let name of propNames) {
            changed = this.props[name] !== prevProps[name] || changed;
        }
        return changed;
    }

    renderBedComponent() {
        switch (this.props.projectType) {
            case GLOBAL_PROJECT_TYPE_CHAMBER:
                return <ChamberBed
                    x={this.props.width / 6}
                    y={this.props.height / 6}
                    height={this.props.width / 4}
                    width={this.props.height / 4}
                    rotation={0}
                    scaleY={1}
                    scaleX={1}
                />;
            case GLOBAL_PROJECT_TYPE_PIPE:
                return <PipeBed
                    x={this.props.width / 6}
                    y={this.props.height / 6}
                    height={this.props.width / 4}
                    width={this.props.height / 4}
                    rotation={0}
                    scaleY={1}
                    scaleX={1}
                />;
            default:
                break;
        }
    }

    async onTabClicked( tab, evt ) {
        const subProjectId_tabKey = tab.props.itemKey;
        const prevSubProjectKey = this.state.nextTabKey;
        this.setState({
            nextTabKey: subProjectId_tabKey,
            previousTabKey: prevSubProjectKey,
        });


        let unsavedChanges = this.props.multibedIsDirty;
        if (subProjectId_tabKey === "overview") {
            // If there are pending changes on the current tab, block transition
            if (unsavedChanges) {
                this.props.showUnsavedChangesDialog();
                evt.preventDefault();
                return false;
            } else {
                this.discardChanges();
            }

        } else {
            if (unsavedChanges) {
                this.props.showUnsavedChangesDialog();
                evt.preventDefault();
                return false;
            } else {
                this.discardChanges();
            }
        }
    }

    async saveSubProject() {
        this.props.loadingBed(true);
        let { nextTabKey, previousTabKey } = this.state;
        if (previousTabKey === null) previousTabKey = "overview";
        if (nextTabKey === null) nextTabKey = "overview";

        const currentTabKeyIsOverview = ( previousTabKey === "overview" );
        const nextTabKeyIsOverview = ( nextTabKey === "overview" );

        let currentTabObject = ( currentTabKeyIsOverview )
            ? MultibedSelectors.getLastBed()
            : MultibedSelectors.getBedById(previousTabKey);

        let nextTabObject = ( nextTabKeyIsOverview )
            ? MultibedSelectors.getLastBed()
            : MultibedSelectors.getBedById(nextTabKey);

        // Save current bed
        const subProjectId = currentTabObject.id;
        const config = { bedName: currentTabObject.name };
        const subProjectInstance = await SubProjectService.saveOrCreateSubProject(subProjectId, config, this.props);
        await SubProjectService.syncAutomationProcess(subProjectInstance, this.props);

        // Save the current placeholder
        let placeholderObj = MultiBedService.getPlaceholderSettings(currentTabObject.name, this.props);
        placeholderObj.bedId = currentTabObject.id;
        this.props.updatePlaceholder(placeholderObj);

        // Save main project
        await SubProjectService.saveMainProject(this.props);

        // clear bed and load next bed
        SubProjectService.clearViewPortForMultiBed(this.props)
            .then(() => {
                let pType = "";
                SubProjectService.loadSubProject(nextTabObject.id, this.props)
                    .then(projectInstance => {
                        pType = projectInstance.projectType;
                        if (projectInstance.projectType === "PIPE") {
                            const {
                                length,
                                width,
                            } = this.props.pipeBed.dimensions;
                            this.props.setPipeDesign(width.ft, length.ft);
                        }
                    })
                    .finally(async () => {
                        this.props.setDirtyStateForMultiBeds(false);
                        if (pType === "PIPE") {
                            await MultiBedService.syncBedsData(this.props.multiBedBeds, this.props);
                        }
                        this.props.loadingBed(false);
                    });
            });

        // switch tab
        // this.props.setSelectedTabKey((nextTabKeyIsOverview) ? 'overview' : nextTabObject.id);
        this.props.hideUnsavedChangesDialog();

        this.navigateToTab(( nextTabKeyIsOverview ) ? "overview" : nextTabObject.id);

    }

    async discardChanges() {
        try {
            this.props.loadingBed(true);
            await SubProjectService.clearViewPortForMultiBed(this.props);
            let lasIdObject;
            if (this.state.nextTabKey === "overview") lasIdObject = MultibedSelectors.getLastBed().id;
            let pType = "";
            await SubProjectService
                .loadSubProject(
                    ( this.state.nextTabKey !== "overview" )
                        ? this.state.nextTabKey
                        : lasIdObject, this.props)
                .then(projectInstance => {
                    pType = projectInstance.projectType;
                    if (projectInstance.projectType === "PIPE") {
                        const {
                            length,
                            width,
                        } = this.props.pipeBed.dimensions;
                        this.props.setPipeDesign(width.ft, length.ft);
                    }
                })
                .finally(async () => {
                    if (pType === "PIPE") {
                        await MultiBedService.syncBedsData(this.props.multiBedBeds, this.props);
                    }
                    return this.props.loadingBed(false);
                });


            this.props.setSelectedTabKey(this.state.nextTabKey);
            this.props.hideUnsavedChangesDialog();
            this.props.setDirtyStateForMultiBeds(false);
            this.navigateToTab(this.state.nextTabKey);


            const isChamber = this.props.projectType === GLOBAL_PROJECT_TYPE_CHAMBER;

            this.props.updatedBedValues(( this.state.nextTabKey !== "overview" )
                    ? this.state.nextTabKey
                    : lasIdObject,
                isChamber,
                this.props);

        } catch (error) {
            console.error(`Viewport.discardChanges() :: ${error.message}`);
        }
    }

    cancelTabChange() {
        this.props.hideUnsavedChangesDialog();
        this.setState({ nextTabKey: null });
        this.navigateToTab(this.props.selectedTabKey);
    }

    navigateToTab( key ) {
        this.props.setSelectedTabKey(key);
        if (key !== "overview") {
            this.props.setSelectedBed(key);
            this.props.backgroundEdit(true);
        }
    }

    processingStatusIsWritable( status ) {
        return !status
            || status === Project.PROCESSING_STATUS.unsubmitted
            || status === Project.PROCESSING_STATUS.success
            || status === Project.PROCESSING_STATUS.failed
            || status === Project.PROCESSING_STATUS.failedDownload
            || status === Project.PROCESSING_STATUS.copied;
    }

    render() {
        const { lang, content } = this.props;
        let stoneBedComponent;
        if (this.props.projectType === GLOBAL_PROJECT_TYPE_CHAMBER) {
            stoneBedComponent = <StoneBed/>;
        }
        const { isMultiBedProject, multibedIsDirty } = this.props;

        const isDirty = ( isMultiBedProject && multibedIsDirty );

        if (!this.isInsideIframe()) {
            const mainStructureRender = () => <div
                ref={node => {
                    this.stageContainer = node;
                }}
            >
                <SystemBuilder/>
                <ManifoldBuilder/>
                <Stage
                    x={this.props.viewportPositionX}
                    y={this.props.viewportPositionY}
                    width={this.props.width}
                    height={this.props.height}
                    ref={node => {
                        this.stageNode = node;
                    }}

                    draggable={!this.props.scaleEdit}

                    dragBoundFunc={( pos ) => {
                        let stage = this.stageNode.getStage();
                        if (this.props.isPanning) {
                            return pos;
                        } else {
                            return stage.getAbsolutePosition();
                        }
                    }}

                    onDragEnd={( event ) => {
                        let stage = this.stageNode.getStage();
                        if (stage._lastPos === undefined || stage !== event.target) {
                            return;
                        }
                        let { x, y } = stage._lastPos;
                        if (x !== this.props.stageX || y !== this.props.stageY) {
                            this.props.positionStage(x, y);
                        }
                    }}

                    onContentClick={( pos, event ) => {
                        let stage = this.stageNode.getStage();
                        if (this.props.isPanning) {
                            return pos;
                        } else {
                            return stage.getAbsolutePosition();
                        }
                    }}

                    onContentMouseMove={( event ) => {
                    }}
                >
                    <Background/>
                    <MeasureLength/>
                    <ScaleLine/>
                    {renderPlaceholders()}
                    {stoneBedComponent}
                    {this.renderBedComponent()}
                    <AddRemoveTool/>
                </Stage>
            </div>;

            const renderPivotItems = ( tabKey ) => {
                let pivotList = [...this.props.multiBedBeds];
                pivotList.unshift(this.props.multiBedBeds[this.props.multiBedBeds.length - 1]);
                return pivotList.map(( bed, index ) => renderPivotItem(index, bed.id, bed.name, tabKey));
            };

            const renderPivotItem = ( index, key, label, tabKey ) => {
                let showSaveOverviewIcon = null, showSaveIcon = null;
                if (isDirty) {
                    if (tabKey === "overview" && index === 0) {
                        showSaveOverviewIcon = "Save";
                        showSaveIcon = null;
                    }
                    if (tabKey === key && index !== 0) {
                        showSaveOverviewIcon = null;
                        showSaveIcon = "Save";
                    }
                }
                return index === 0
                    ? (
                        <PivotItem
                            headerText={content[lang].overview}
                            key="overview"
                            itemIcon={showSaveOverviewIcon}
                            onRenderItemLink={_customRenderer}
                            itemKey="overview"
                            className={"pivot_tabs_items"}
                        >
                            {/* Viewport moved outside of the tab to make it more performant */}
                        </PivotItem>
                    )
                    : (
                        <PivotItem
                            headerText={label}
                            itemIcon={showSaveIcon}
                            onRenderItemLink={_customRenderer}
                            key={key}
                            itemKey={key}
                            className={"pivot_tabs_items"}
                        >
                            {/* Viewport moved outside of the tab to make it more performant */}
                        </PivotItem>
                    );
            };

            const _customRenderer = ( link, defaultRenderer ) => {
                if (!link || !defaultRenderer) return null;
                return (
                    <span style={{ flex: "0 1 100%" }}>
                        <Icon iconName={link.itemIcon} style={{ color: "#fff", marginRight: "5px" }}/>
                        {defaultRenderer({ ...link, itemIcon: undefined })}
                    </span>
                );
            };

            const renderPlaceholders = () => {
                try {

                    if (this.props.isMultiBedProject
                        && this.props.multiBedPlaceholders
                        && this.props.multiBedPlaceholders.length
                        && this.props.selectedTabKey === "overview") {

                        let placeholders = [];
                        for (let index = 0; index < this.props.multiBedBeds.length - 1; index++) {
                            const currentBed = this.props.multiBedBeds[index];

                            const placeholder = [...this.props.multiBedPlaceholders].find(bed => {
                                return ( bed && bed.bedId ) ? bed.bedId === currentBed.id : null;
                            });

                            if (placeholder) {
                                placeholders.push((
                                    <Placeholder key={placeholder.bedId}
                                                 bedId={placeholder.bedId}
                                                 bedName={placeholder.bedName}
                                                 points={placeholder.points}
                                                 x={placeholder.x}
                                                 scaleX={placeholder.scaleX}
                                                 scaleY={placeholder.scaleY}
                                                 y={placeholder.y}
                                                 height={placeholder.height}
                                                 width={placeholder.width}
                                                 rotation={placeholder.rotation}/>
                                ));
                            }
                        }
                        return placeholders;
                    }
                } catch (error) {
                    console.error(`Viewport.renderPlaceholders() :: ${error.message}`);
                }
                return null;
            };

            const renderUnsavedMultiBedDialog = () => {
                const disabled = !this.processingStatusIsWritable(this.props.project.processingStatus);
                return (
                    <Dialog
                        hidden={!this.props.isUnsavedChangesDialogVisible}
                        modalProps={{
                            containerClassName: "unsavedChangesContainer",
                        }}
                        dialogContentProps={{
                            type: DialogType.normal,
                            showCloseButton: false,
                            title: content[lang].unsavedChangesDetected,
                            titleId: "unsavedChangesTitle",
                        }}>
                        <DialogContent>
                            {content[lang].youMustSaveYourChanges}
                        </DialogContent>
                        <DialogFooter styles={{ textAlign: "center" }}>
                            <PrimaryButton onClick={this.saveSubProject.bind(this)}
                                           text={content[lang].saveChanges}
                                           className={"secondary_black_ads"}
                                           disabled={disabled}
                            />
                            <DefaultButton onClick={this.discardChanges.bind(this)}
                                           text={content[lang].discardChanges}
                                           className={"caution_blue_ads"}/>
                            <DefaultButton onClick={this.cancelTabChange.bind(this)}
                                           text={content[lang].cancel}
                                           className={"caution_blue_ads"}/>
                        </DialogFooter>
                    </Dialog>
                );
            };

            return (
                ( isMultiBedProject ) ?
                    <div style={{ textAlign: "left" }}>
                        {mainStructureRender()}
                        <Pivot
                            aria-label=""
                            linkSize={45}
                            linkFormat={PivotLinkFormat.tabs}
                            className={"pivot_tabs"}
                            selectedKey={this.props.selectedTabKey}
                            onLinkClick={this.onTabClicked.bind(this)}
                        >
                            {renderPivotItems(this.props.selectedTabKey)}
                        </Pivot>
                        {renderUnsavedMultiBedDialog()}
                    </div> :
                    mainStructureRender()
            );

        } else {
            return <div/>;
        }
    }
}

const mapStateToProps = state => {
    const projectType = state.globals.projectType;
    let positionX, positionY, viewportScaleX, viewportScaleY, scaleData = {};

    if (projectType === GLOBAL_PROJECT_TYPE_CHAMBER) {
        positionX = state.viewport.positionX;
        positionY = state.viewport.positionY;
        viewportScaleX = state.viewport.scaleX;
        viewportScaleY = state.viewport.scaleY;
    } else {
        positionX = state.viewport.positionXPipes;
        positionY = state.viewport.positionYPipes;
        viewportScaleX = state.viewport.scaleXPipes;
        viewportScaleY = state.viewport.scaleXPipes;
    }

    if (
        state.project &&
        state.project.project &&
        state.project.project.projectType
    ) {

        scaleData["projectType"] = state.project.project.projectType;

        scaleData["scaleValue"] = ( state.project.project.projectType === "CHAMBER" )
            ? state.globals.scaleValue
            : state.pipeGlobals.scaleValue;

        scaleData["scalePixels"] = ( state.project.project.projectType === "CHAMBER" )
            ? state.globals.scalePixels
            : state.pipeGlobals.scalePixels;

    } else {
        scaleData = {};
    }

    const isChamber = state.globals.projectType === GLOBAL_PROJECT_TYPE_CHAMBER;

    return {
        isPanning: state.viewport.isPanning,
        viewportScaleX: viewportScaleX,
        viewportScaleY: viewportScaleY,
        viewportPositionX: positionX,
        viewportPositionY: positionY,
        user: state.authentication.user,
        computedHeight: state.viewport.computedHeight,
        computeWidth: state.viewport.computeWidth,
        pressedKeys: state.globals.pressedKeys,
        keysOfInterest: state.globals.keysOfInterest,
        projectType: state.globals.projectType,
        scaleEdit: state.drawingToolbar.scaleEdit,
        measureToolEdit: state.drawingToolbar.measureToolEdit,

        chamberbedScaleX: state.chamberbed.scaleX,
        chamberbedScaleY: state.chamberbed.scaleY,
        chamberbedHeight: state.chamberbed.height,
        chamberbedWidth: state.chamberbed.width,
        bedWidth: state.pipeBed.dimensions.width.px,
        bedLength: state.pipeBed.dimensions.length.px,

        mouseClickMeasure: state.measuretool.mouseClickMeasure,
        isMultiBedProject: ProjectSelectors.isMultiBedProject(),
        multiBedBeds: state.multiBed.beds,
        selectedBed: state.multiBed.selectedBed,
        project: state.project.project,
        resourcesTokens: state.authentication.resourcesTokens,
        isUnsavedChangesDialogVisible: state.multiBed.isUnsavedChangesDialogVisible,
        selectedTabKey: state.multiBed.selectedTabKey,
        multiBedPlaceholders: state.multiBed.placeholders,
        region: state.localization.region,

        stoneBedPoints: state.stonebed.points,
        chamberbedX: state.chamberbed.x,
        chamberbedY: state.chamberbed.y,
        pipeBedPosition: state.pipeBed.position,
        chamberbedRotation: state.chamberbed.rotation,
        pipeBedRotation: state.pipeBed.rotation,
        pipeBedDimensions: state.pipeBed.dimensions,
        pipeBed: state.pipeBed,
        pipeGlobals: state.pipeGlobals,
        multibedIsDirty: state.multiBed.isDirty,
        multiBedOtherUserId: state.multiBed.otherUserId,
        multiBedOtherUserTokens: state.multiBed.otherUserTokens,
        lang: state.localization.lang,
        content: state.localization.content,
        scaleData: scaleData,
        unit: state.localization.unit,

        systemVolume: isChamber
            ? state.calculations.totalStorageProvided
            : state.pipeBed.pipeBedVolume,
        systemLength: isChamber
            ? state.calculations.systemLength
            : state.pipeBed.stoneBedDimensions.height ? state.pipeBed.stoneBedDimensions.height.ft : 0,
        systemWidth: isChamber
            ? state.calculations.systemWidth
            : state.pipeBed.stoneBedDimensions.width ? state.pipeBed.stoneBedDimensions.width.ft : 0,
        systemArea: isChamber
            ? state.calculations.rectangularFootprint
            : state.pipeBed.area,
        requiredChambers: state.calculations.requiredChambers,
        requiredEndCaps: state.calculations.requiredEndCaps,
        numberOfPipeRows: state.pipeBed.numberOfPipeRows,
        pipeBedCenterFittingDimensions: state.pipeBed.centerFittingDimensions,
        pipeRowBedDimensions: state.pipeBed.rowBedDimensions,
        pipeBedPipeBedDimensions: state.pipeBed.pipeBedDimensions,

        chamberTypeName: state.globals.chamberType.name,

        pipeTypeName: state.pipeGlobals.pipeFitting._name,
        pipeSizeNominalDiameter: state.pipeGlobals.pipeNominalDiameter._pipeND._inches,


    };
};

const mapDispatchToProps = {
    chamberBedSetCentralizedCoordinates,
    pipeBedSetCentralizedCoordinates,
    setDimensions,
    addPressedKey,
    deletePressedKey,
    scaleStage,
    positionStage,
    switchPanning,
    modalAlertActions,
    showUnsavedChangesDialog,
    hideUnsavedChangesDialog,
    setSelectedTabKey,
    clearViewPort,
    setCurrentSubProject,
    clearMainManifoldsState,
    restoreSubProjectPersistedState,
    getSubProjectStateToPersist,
    updatePlaceholder,
    getScaledValue,
    getStateToPersist,
    loadingBed,
    setPipeDesign,
    setSelectedBed,
    setDirtyStateForMultiBeds,
    buildProjectAutomation,
    buildPipeProjectAutomation,
    backgroundEdit,
    getStagePosition,
    getStageScale,

    emitLineLenght,
    scaleUnitValueChange,
    scaleEditSwitch,
    updatedBedValues,

    updatedSelectedBedValues,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Viewport);



// WEBPACK FOOTER //
// ./src/components/Viewport/index.js